import { PublicNav } from "@/components/public/PublicNav";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Optimistic skeleton for public marketing pages (TireHotel, BookingInfo,
 * Pricing, Auth). Renders the real PublicNav immediately (already in the
 * shared chunk from Index) so the top of the page feels instant, then
 * shows shimmering placeholders where the hero/content will hydrate.
 */
export const PublicPageSkeleton = () => (
  <div className="min-h-screen bg-background flex flex-col">
    <PublicNav />
    <main className="flex-1">
      <section className="max-w-[1100px] mx-auto px-4 sm:px-6 pt-16 sm:pt-20 pb-12">
        <div className="flex flex-col items-center gap-6">
          <Skeleton className="h-12 sm:h-16 w-3/4 max-w-2xl" />
          <Skeleton className="h-12 sm:h-16 w-2/3 max-w-xl" />
          <div className="w-full max-w-xl space-y-3 mt-4">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6 mx-auto" />
          </div>
          <div className="flex gap-3 mt-4">
            <Skeleton className="h-12 w-40 rounded-[10px]" />
            <Skeleton className="h-12 w-32 rounded-[10px]" />
          </div>
        </div>
      </section>
      <section className="max-w-[1100px] mx-auto px-4 sm:px-6 pb-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-24 rounded-lg" />
          ))}
        </div>
      </section>
      <section className="max-w-[1100px] mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-10">
        <div className="space-y-4">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-10 w-3/4" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-2/3" />
        </div>
        <Skeleton className="h-56 rounded-xl" />
      </section>
    </main>
  </div>
);

export default PublicPageSkeleton;